import { FileReader, FileWriter } from "@/platform";
import ModuleId from "./DataStructModuleId";
class Hashtable {

	Data: Record<string, any> = {}

    readBin(reader: FileReader): void {
		const len = reader.readInt()
		this.Data = {}
        for ( var i = 0; i < len; i++ ){
			let key = reader.readString()
            var type = reader.readInt()
			if (type === 1) {
                // string
                this.Data[key] = reader.readString()
            } else if (type === 2) {
                // number
                this.Data[key] = reader.readInt()
            } else if (type === 3) {
                // boolean
                this.Data[key] = reader.readInt() === 1
            } else if (type === 4) {
                // undefined
                this.Data[key] = reader.readString()
            } else if (type === 5) {
                // json string
                this.Data[key] = JSON.parse(reader.readString())
            }
		}
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(Object.keys(this.Data).length)
        for (const key in this.Data) {
            writer.writeString(key)
            writer.writeInt(typeof this.Data[key] === 'string' ? 1 : typeof this.Data[key] === 'number' ? 2 : typeof this.Data[key] === 'boolean' ? 3 : 4)
            if (typeof this.Data[key] === 'string') {
                writer.writeString(this.Data[key])
            } else if (typeof this.Data[key] === 'number') writer.writeInt(this.Data[key])
            else if (typeof this.Data[key] === 'boolean') writer.writeInt(this.Data[key] ? 1 : 0)
            else writer.writeString(JSON.stringify(this.Data[key]))
        }
    }
}
export default Hashtable